"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _vuescroll = _interopRequireDefault(require("vuescroll"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  components: {
    vuescroll: _vuescroll.default
  },
  props: {
    // 数据表头list列表 可以把整个tableColumn传进来
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 默认选中的指标
    indicatorDefault: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      ops: {
        // 滚动条参数配置
        bar: {
          keepShow: true
        },
        scrollPanel: {
          scrollingX: false
        }
      },
      checkRadioGroup: '',
      // 数组选中的选项
      showChecked: {} // 确定选中的选项
    };
  },

  watch: {
    list: {
      handler: function handler() {
        this.init();
      },
      deep: true,
      immediate: true
    },
    indicatorDefault: {
      handler: function handler() {
        this.init();
      },
      deep: true
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    init: function init() {
      var _this = this;
      this.checkRadioGroup = this.list.find(function (item) {
        return item.key === _this.indicatorDefault;
      }).key;
      this.checkRadioGroupChange(this.checkRadioGroup);
      // 刷新滚动条
      _vuescroll.default.refreshAll();
    },
    /**
    * @description 打开事件
    */
    handleOpen: function handleOpen() {
      this.init();
    },
    /**
    * @description 取消按钮事件
    */
    handleClose: function handleClose() {
      // 重置参数
      this.init();
      this.$refs.indicatorSelect.hide();
    },
    /**
    * @description 保存按钮事件
    */
    handleSave: function handleSave() {
      this.$emit('select', this.showChecked);
      this.$refs.indicatorSelect.hide();
    },
    /**
    * @description 指标选择事件
    */
    checkRadioGroupChange: function checkRadioGroupChange(value) {
      this.showChecked = this.list.find(function (item) {
        return value === item.key;
      });
    }
  }
};
exports.default = _default2;